// extracted by mini-css-extract-plugin
export default {"openBets":"styles_openBets__Tfl0C","empty":"styles_empty__V4y29"};